import Home from "pages/Home";
import "./App.css";
import {
  createBrowserRouter,
  Link,
  RouterProvider,
  useLocation,
} from "react-router-dom";
import ProjectsPage from "pages/ProjectsPage";
import ProjectsCompanyPage from "pages/ProjectsCompanyPage";
import { useEffect, useState } from "react";
import { FaPhone, FaWhatsapp } from "react-icons/fa6";
import ProjectDetailPage from "pages/ProjectDetailPage";
import ScrollToTop from "components/ScrooltoTop";
import AboutPage from "pages/AboutPage";
import Request from "pages/Request";
import i18next from "i18next";
import global_en from "./translation/en/global.json";
import global_fa from "./translation/fa/global.json";
import global_ar from "./translation/ar/global.json";
import global_ru from "./translation/ru/global.json";
import { I18nextProvider, useTranslation } from "react-i18next";
import MapPage from "pages/MapPage";
import ContactPage from "pages/ContactPage";
import CategoryPage from "pages/CategoryPage";
import SubCategoryPage from "pages/SubCategoryPage";
import ProductDetailsPage from "pages/ProductDetailsPage";
import { CartContext } from "context/CartContext";
import CartPage from "pages/CartPage";
import CheckoutPage from "pages/CheckoutPage";
import LoginPage from "pages/Loginpage";
import Signpage from "pages/Signpage";
import AccountPage from "pages/AccountPage";
import OrdersPage from "pages/OrdersPage";
import BillsPage from "pages/BillsPage";
import PartnerSignpage from "pages/PartnerSignpage";
import PartnerAccountPage from "pages/PartnerAccountPage";
import WalletPage from "pages/WalletPage";
import SuccessfullPayment from "pages/SuccessfullPayment";
import { FavoriteContext } from "context/FavoriteContext";
import TermsPage from "pages/TermsPage";
import PrivacyPolicyPage from "pages/PrivacyPolicyPage";
import CareersPage from "pages/CareersPage";
import SellWithUsPage from "pages/SellWithUsPage";
import WarrantyPolicyPage from "pages/WarrantyPolicyPage";
import ReturnRefundPage from "pages/ReturnRefundPage";
import TermsOfSalePage from "pages/TermsOfSalePage";
import TermsOfUsePage from "pages/TermsOfUsePage";
import ConsumerRightsPage from "pages/ConsumerRightsPage";
import PaymentCallback from "pages/PaymentCallback";

i18next.init({
  interpolation: { escapeValue: false },
  lng: "en",
  resources: {
    en: { global: global_en },
    fa: { global: global_fa },
    ar: { global: global_ar },
    ru: { global: global_ru },
  },
});

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <>
          <ScrollToTop />
          <Home />
        </>
      ),
    },
    {
      path: "/dashboard",
      element: (
        <>
          <ScrollToTop />
          <AccountPage />
        </>
      ),
    },
    {
      path: "/careers",
      element: (
        <>
          <ScrollToTop />
          <CareersPage />
        </>
      ),
    },
    {
      path: "/sell-with-us",
      element: (
        <>
          <ScrollToTop />
          <SellWithUsPage />
        </>
      ),
    },
     {
      path: "/payment-callback",
      element: (
        <>
          <ScrollToTop />
          <PaymentCallback />
        </>
      ),
    },
    {
      path: "/warranty-policy",
      element: (
        <>
          <ScrollToTop />
          <WarrantyPolicyPage />
        </>
      ),
    },
    {
      path: "/return-refund",
      element: (
        <>
          <ScrollToTop />
          <ReturnRefundPage />
        </>
      ),
    },
    {
      path: "/terms-of-sale",
      element: (
        <>
          <ScrollToTop />
          <TermsOfSalePage />
        </>
      ),
    },
    {
      path: "/terms-of-use",
      element: (
        <>
          <ScrollToTop />
          <TermsOfUsePage />
        </>
      ),
    },
    {
      path: "/consumer-rights",
      element: (
        <>
          <ScrollToTop />
          <ConsumerRightsPage />
        </>
      ),
    },
    {
      path: "/partner/dashboard",
      element: (
        <>
          <ScrollToTop />
          <PartnerAccountPage />
        </>
      ),
    },
    {
      path: "/dashboard/orders",
      element: (
        <>
          <ScrollToTop />
          <OrdersPage />
        </>
      ),
    },
    {
      path: "/successful-payment",
      element: (
        <>
          <ScrollToTop />
          <SuccessfullPayment />
        </>
      ),
    },
    {
      path: "/dashboard/bills",
      element: (
        <>
          <ScrollToTop />
          <BillsPage />
        </>
      ),
    },
    {
      path: "/dashboard/wallet",
      element: (
        <>
          <ScrollToTop />
          <WalletPage />
        </>
      ),
    },
    {
      path: "/sign",
      element: (
        <>
          <ScrollToTop />
          <Signpage />
        </>
      ),
    },
    {
      path: "/sign/partner",
      element: (
        <>
          <ScrollToTop />
          <PartnerSignpage />
        </>
      ),
    },
    {
      path: "/category/:name",
      element: (
        <>
          <ScrollToTop />
          <CategoryPage />
        </>
      ),
    },
    {
      path: "/category/:name/:sub",
      element: (
        <>
          <ScrollToTop />
          <SubCategoryPage />
        </>
      ),
    },
    {
      path: "/product/:name",
      element: (
        <>
          <ScrollToTop />
          <ProductDetailsPage />
        </>
      ),
    },

    {
      path: "/contact",
      element: (
        <>
          <ScrollToTop />
          <ContactPage />
        </>
      ),
    },
    {
      path: "/cart",
      element: (
        <>
          <ScrollToTop />
          <CartPage />
        </>
      ),
    },
    {
      path: "/terms",
      element: (
        <>
          <ScrollToTop />
          <TermsPage />
        </>
      ),
    },
    {
      path: "/privacy",
      element: (
        <>
          <ScrollToTop />
          <PrivacyPolicyPage />
        </>
      ),
    },
    {
      path: "/checkout",
      element: (
        <>
          <ScrollToTop />
          <CheckoutPage />
        </>
      ),
    },
    {
      path: "/about",
      element: (
        <>
          <ScrollToTop />
          <AboutPage />
        </>
      ),
    },
  ]);

  const [cart, setCart] = useState([]);
  const [cartshow, setCartshow] = useState(false);
  const [favorite, setfavorite] = useState([]);
  const [favoriteshow, setfavoriteshow] = useState(false);

  return (
    <>
      <I18nextProvider i18n={i18next}>
        <CartContext.Provider
          value={{
            cart,
            setCart,
            cartshow,
            setCartshow,
          }}
        >
          <FavoriteContext.Provider
            value={{ favorite, setfavorite, favoriteshow, setfavoriteshow }}
          >
            <RouterProvider router={router} />
          </FavoriteContext.Provider>
        </CartContext.Provider>
      </I18nextProvider>
    </>
  );
}

export default App;
